for (const slider of document.querySelectorAll('.layout-slider')) {
  const dom = {
    list: slider.querySelector('.list'),
    items: slider.querySelectorAll('.list > *'),
    nav: slider.querySelector('nav'),
    controls: slider.querySelector('.controls'),
    prev: slider.querySelector('.prev'),
    next: slider.querySelector('.next'),
  }

  let current = dom.items[0] || null
  const autoplay = parseInt(slider.dataset.autoplay || 0, 10)
  const loop = !!slider.dataset.loop

  const calculate = (el) => {
    if (!el) return

    let prev, next
    const realNavigation = current !== el
    current = el
    slider.dataset.current = '#' + el.id
    prev = displayedSibling(false, el)
    next = displayedSibling(true, el)
    if (loop) {
      prev = prev || lastDisplayedChild(dom.list)
      next = next || firstDisplayedChild(dom.list)
    }
    slider.dataset.prev = prev ? '#' + prev.id : ''
    slider.dataset.next = next ? '#' + next.id : ''

    if (dom.nav) {
      dom.nav.querySelector('.on')?.classList.remove('on')
      dom.nav
        .querySelector(`[href="${slider.dataset.current}"]`)
        ?.classList.add('on')
      const links = dom.nav.querySelectorAll('[href]')
      for (const [index, item] of dom.items.entries()) {
        links[index].classList.toggle('disabled', !isDisplayed(item))
      }
    }

    if (dom.controls && dom.prev && dom.next) {
      dom.prev.href = slider.dataset.prev
      dom.next.href = slider.dataset.next
      dom.prev.classList.toggle('on', slider.dataset.prev !== '')
      dom.next.classList.toggle('on', slider.dataset.next !== '')
    }

    if (realNavigation) {
      slider.dispatchEvent(
        new CustomEvent('navigate', { detail: { slider, dom, current } })
      )
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          calculate(entry.target)
        }
      }
    },
    { threshold: 0.5 }
  )
  for (const item of dom.items) {
    observer.observe(item)
    item.addEventListener('navigate', () => {
      const hash = '#' + item.id

      if (hash?.startsWith('#')) {
        navigateTo(hash)
      }
    })
  }

  const isDisplayed = (el) => {
    return getComputedStyle(el).getPropertyValue('display') !== 'none'
  }

  const displayedSibling = (next, el) => {
    do {
      el = next ? el.nextElementSibling : el.previousElementSibling
    } while (el && !isDisplayed(el))
    return el || null
  }

  const firstDisplayedChild = (parent) => {
    let el = parent.firstElementChild
    if (el && !isDisplayed(el)) {
      el = displayedSibling(true, el)
    }
    return el || null
  }

  const lastDisplayedChild = (parent) => {
    let el = parent.lastElementChild
    if (el && !isDisplayed(el)) {
      el = displayedSibling(false, el)
    }
    return el || null
  }

  const navigateTo = (hash) => {
    if (hash?.startsWith('#')) {
      dom.list.scrollTo({
        top: 0,
        left: document.querySelector(hash)?.offsetLeft || 0,
        behavior: 'smooth',
      })
    }
  }

  const navHandler = (e) => {
    e.preventDefault()
    const hash = e.target.getAttribute('href')
    navigateTo(hash)
  }

  const keyHandler = (e) => {
    if (['Enter', 'Space'].includes(e.code)) {
      e.preventDefault()
      navHandler(e)
    }
  }

  if (dom.nav) {
    dom.nav.addEventListener('click', navHandler)
    dom.nav.addEventListener('keypress', keyHandler)
  }

  if (dom.controls) {
    dom.controls.addEventListener('click', navHandler)
    dom.controls.addEventListener('keypress', keyHandler)
  }

  if (autoplay) {
    let interval = null
    const start = () => {
      interval = setInterval(() => {
        navigateTo(slider.dataset.next)
      }, autoplay)
    }
    const stop = () => {
      clearInterval(interval)
    }
    slider.addEventListener('mouseenter', stop)
    slider.addEventListener('mouseleave', start)
    start()
  }

  slider.addEventListener('refresh', () => {
    calculate(current)
  })
  slider.addEventListener('navigate', () => {
    calculate(current)
  })
  slider.addEventListener('prev', () => {
    navigateTo(slider.dataset.prev)
  })
  slider.addEventListener('next', () => {
    navigateTo(slider.dataset.next)
  })
}
